<!-- 标签管理列表 -->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.addRole" @click="showRoleInfoes()">{{ permission.addRole }}</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column min-width="150px" prop="RoleName" label="联盟角色" show-overflow-tooltip> </el-table-column>
                    <el-table-column min-width="200px" prop="Remark" label="备注说明" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="State" label="当前状态" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="Creator" label="创建人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="showRoleInfoes(scope.row.RoleId)" v-if="permission.editRole">{{ permission.editRole }}</el-button>
                                <el-button type="text" size="mini" style="color: orange" @click="roleAuthEdit(scope.row)" v-if="permission.rolePermission">{{
                                    permission.rolePermission
                                }}</el-button>
                                <el-button type="text" size="mini" style="color: red" @click="delRole(scope.row.RoleId)" v-if="permission.delRole">{{
                                    permission.delRole
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="角色信息" :visible.sync="dialogRoleVisible" width="1000px">
            <div class="dialog-content" v-if="dialogRoleVisible">
                <UnionRoleEdit ref="roleEdit" :roleId="roleId" @closeDialog="closeRoleDialog"></UnionRoleEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="authTitle" :visible.sync="dialogRoleAuthVisible" width="1000px">
            <div class="dialog-content" v-if="dialogRoleAuthVisible">
                <UnionRoleAuthEdit ref="roleAuthEdit" :roleId="roleId" @closeDialog="closeRoleAuthDialog"></UnionRoleAuthEdit>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import UnionRoleEdit from '@/components/entpUnion/entityManage/unionRoleEdit';
import UnionRoleAuthEdit from '@/components/entpUnion/entityManage/unionRoleAuthEdit';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'labels',
    components: {
        breadcrumb,
        elTableColumn,
        UnionRoleEdit,
        UnionRoleAuthEdit
    },
    data() {
        return {
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                RoleName: '',
                State: '',
                page: 1,
                limit: 15
            },
            noData: false,
            loading: false,
            roleId: '',
            authTitle: '',
            dialogRoleVisible: false,
            dialogRoleAuthVisible: false,
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getUnionPermission('UnionRoleSets');
    },
    methods: {
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                RoleName: '',
                State: '',
                page: 1,
                limit: 15
            };
        },
        // 获取数据
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionRoleList',
                    data: that.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        that.noData = true;
                        return;
                    }
                    that.noData = false;
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showRoleInfoes(roleId) {
            if (roleId) {
                this.roleId = roleId;
            } else {
                this.roleId = '';
            }
            this.dialogRoleVisible = true;
        },
        closeRoleDialog(isEdit) {
            if (isEdit) {
                this.getTableData();
            }
            this.dialogRoleVisible = false;
        },
        roleAuthEdit(item) {
            if (item) {
                this.roleId = item.RoleId;
                this.authTitle = '为角色【' + item.RoleName + '】分配权限';
            }
            this.dialogRoleAuthVisible = true;
        },
        closeRoleAuthDialog() {
            this.dialogRoleAuthVisible = false;
        },
        delRole(roleId) {
            let that = this;
            if (roleId) {
                that.$confirm('您确认要删除该角色吗？', '提示', {
                    confirmButtonText: '确定继续删除',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/DelRoleData',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    RoleId: roleId
                                },
                                hideLoading: true
                            })
                            .then(() => {
                                that.$util.successMsg('成功删除角色');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            } else that.$util.warningMsg('请选择要删除的角色');
        }
    }
};
</script>
